import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card } from "antd";
import { toSetString, toDateString, toPatentDetailLink, toTitleCase, toGooglePatentLink } from "../../helpers/converters";
import { withUser } from "@unifiedpatents/sso";
import { Link } from "react-router";

const styles = {
  verticalGutter: {
    marginBottom: 8
  }
};

const BiographicData = props => {
  const { data } = props;
  const valueRenderer = v => (v ? v : "N/A");
  return (
    <Card title="Details">
      <Row gutter={16}>
        <Col span={24} lg={8}>
          <div style={styles.verticalGutter}>
            <strong>{"Application Number:"}</strong> {valueRenderer(data.application_number)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Filing Date:"}</strong> {valueRenderer(data.filing_date)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Status:"}</strong> {valueRenderer(data.exparte_status ? data.exparte_status : data.application_status)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Last Updated:"}</strong> {valueRenderer(toDateString(data.application_status_date))}
          </div>
        </Col>
        <Col span={24} lg={8}>
          <div style={styles.verticalGutter}>
            <strong>{"Patent:"}</strong> {data.patent_number ? (
              <>
                {toPatentDetailLink(data.patent_number)}
                {toGooglePatentLink(`US${data.patent_number}`)}
              </>
            ) : "N/A"}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Group Art Unit:"}</strong> {data.examiner_art_unit ? <Link to={`/prosecution/artunit/${data.examiner_art_unit}`}>{toTitleCase(data.examiner_art_unit)}</Link> : "N/A"}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Class:"}</strong> {valueRenderer(data.national_class)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Subclass:"}</strong> {valueRenderer(data.national_subclass)}
          </div>
        </Col>
        <Col span={24} lg={8}>
          <div style={styles.verticalGutter}>
            <strong>{"Examiner:"}</strong> {data.examiner_name ? <Link to={`/prosecution/examiner/${data.examiner_name}`}>{toTitleCase(data.examiner_name)}</Link> : "N/A"}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Law Firm:"}</strong> {valueRenderer(data.law_firm)}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Patent Owner:"}</strong> {valueRenderer(toSetString(data.owner))}
          </div>
          <div style={styles.verticalGutter}>
            <strong>{"Requester:"}</strong> {valueRenderer(toSetString(data.requester))}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

BiographicData.propTypes = {
  data: PropTypes.object.isRequired
};

export default withUser(BiographicData);
